import { useMiniApp } from '@app/providers/miniapp-provider'
import { useEffect, useState } from 'react'

const useMobileView = () => {
    const [isMobile, setIsMobile] = useState(false)
    const { isMiniApp } = useMiniApp()

    useEffect(() => {
        const checkIfMobile = () => {
            const mobileBreakpoint = 768 // Ширина экрана, при которой считаем, что это мобильное устройство
            setIsMobile(window.innerWidth <= mobileBreakpoint)
        }

        // Проверяем при монтировании компонента
        checkIfMobile()

        // Добавляем слушатель изменения размера окна
        window.addEventListener('resize', checkIfMobile)

        // Убираем слушатель при размонтировании компонента
        return () => window.removeEventListener('resize', checkIfMobile)
    }, [])

    return isMobile || isMiniApp
}

export default useMobileView
